
import { format as formatNumber } from '@/project/filters/formatNumber/formatNumber'
import { format as formatText } from '@/project/filters/formatText/formatText'

const _createAvatar = (createElement, channel) => {
  if (channel.avatar) {
    return createElement('BaseImage', {
      class:
        'flex flex-shrink-0 w-10 h-10 items-center justify-center rounded-full',
      attrs: {
        src: channel.avatar,
        alt: channel.title,
        lazy: false,
        size: {
          sm: 48,
          md: 48,
          lg: 48,
        },
      },
    })
  } else {
    return createElement(
      'div',
      {
        class:
          'flex flex-shrink-0 w-10 h-10 items-center justify-center bg-gray-5 text-gray-1 rounded-full',
      },
      [
        createElement('CoreIcon', {
          class: 'w-8 h-8 fill-current',
          attrs: {
            name: 'camera',
          },
        }),
      ]
    )
  }
}

const _createData = (createElement, channel) =>
  createElement(
    'div',
    {
      class: 'flex flex-col items-start ml-2.5',
    },
    [
      createElement(
        'a',
        {
          attrs: {
            href: channel.link.url,
            target: '_blank',
            rel: 'noopener',
            title: `Перейти в группу «${channel.title}»`,
          },
        },
        [
          createElement(
            'h2',
            {
              class:
                'text-comment text-gray-1 font-medium hover:text-link transition',
            },
            channel.title
          ),
          createElement(
            'p',
            {
              class: 'text-comment text-gray-3 mt-1',
            },
            formatText(formatNumber(channel.auditorium), [
              'подписчик',
              'подписчика',
              'подписчиков',
            ])
          ),
        ]
      ),
      createElement(
        'a',
        {
          class:
            'mt-1 text-comment text-accent hover:text-accent-light line-clamp-1 transition',
          attrs: {
            href: channel.link.url,
            target: '_blank',
            rel: 'noopener',
            title: `Перейти в группу «${channel.title}»`,
          },
        },
        'Подписаться'
      ),
    ]
  )

const _createElement = (createElement, channel, tag, data) => {
  if (tag === 'li') {
    return createElement(
      'li',
      {
        class: `w-full flex items-start py-3.5 px-5 bg-primary-bg border border-gray-5 rounded-md ${data.staticClass}`,
      },
      [
        createElement(
          'a',
          {
            class:
              'hover:shadow transition w-10 h-10 rounded-full flex-shrink-0',
            attrs: {
              href: channel.link.url,
              target: '_blank',
              rel: 'noopener',
            },
          },
          [_createAvatar(createElement, channel)]
        ),

        _createData(createElement, channel),
      ]
    )
  } else {
    return createElement(
      'div',
      {
        class: 'flex items-start',
      },
      [
        createElement(
          'a',
          {
            class:
              'hover:shadow transition w-10 h-10 rounded-full flex-shrink-0',
            attrs: {
              href: channel.link.url,
              target: '_blank',
              rel: 'noopener',
            },
          },
          [_createAvatar(createElement, channel)]
        ),

        _createData(createElement, channel),
      ]
    )
  }
}
export default {
  name: 'MegasredaRecomendedSocialItem',
  functional: true,
  props: {
    channel: {
      type: Object,
      default: null,
    },
    tag: {
      type: String,
      default: 'li',
    },
  },
  render(createElement, { props, data }) {
    return _createElement(createElement, props.channel, props.tag, data)
  },
}
